import { Component, OnInit } from '@angular/core';
import { UserDao } from '@app/dao/user/user.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { take } from 'rxjs';
import riskStatus from '../risk-status';

@Component({
    selector: 'investor-profile',
    templateUrl: './investor-profile.component.html',
    styleUrls: ['./investor-profile.component.scss'],
    standalone: false
})
export class InvestorProfileComponent implements OnInit {
  toggle: boolean = false;
  riskStatus: string = '';

  minRiskThreshold = 3;
  maxRiskThreshold = 4;
  constructor(
    private subscriptionFacade: SubscriptionFacadeService,
    private useDao: UserDao,
  ) {}

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    const owners = pledge.owners;
    this.useDao
      .getAuthentified()
      .pipe(take(1))
      .subscribe(user => {
        const { riskProfil } =
          owners?.find(owner => owner.id === user.id) || owners?.[0] || {};

        this.riskStatus = riskStatus.getRiskStatus(riskProfil?.score);
      });
  }

  readMore() {
    this.toggle = !this.toggle;
  }

  readLess() {
    this.toggle = !this.toggle;
  }
}
